module.exports = __webpack_public_path__ + "img/4.5325f494.png";